  import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, Input, Output, EventEmitter, ChangeDetectorRef, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { of, ReplaySubject, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, mergeMap, take, takeUntil, tap } from 'rxjs/operators';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { IDropdown } from '../dropdown-interface';
import { Icons } from '@vex/icons/icons';
import { ToastrService } from 'ngx-toastr';
import { PopoverService } from '@vex/components/popover/popover/popover.service';
import { PopoverTooltipComponent } from '@vex/components/popover/popover-tooltip/popover-tooltip.component';
import { MatSelectSearchComponent } from '@vex/components/mat-select-search/mat-select-search.component';
import { TooltipReadMoreComponent } from '@vex/components/popover/popover-tooltip/tooltip-read-more/tooltip-read-more.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'vex-multiple-selection-select-all',
  templateUrl: './multiple-selection-select-all.component.html',
  styleUrls: ['./multiple-selection-select-all.component.scss']
})
export class MultipleSelectionSelectAllComponent extends Icons implements OnInit, AfterViewInit, OnDestroy {

  setting: any = {};
  formControl: any = {};
  mySelections: any[] = [];
  oldValue: any[] = []
  /** list of value */
  options: any[] = [];

  /** control for the selected value for multi-selection */
  formMultiCtrl: FormControl = new FormControl();

  /** control for the MatSelect filter keyword multi-selection */
  formMultiFilterCtrl: FormControl = new FormControl();

  /** list of values filtered by search keyword */
  filteredValuesMulti: ReplaySubject<IDropdown[]> = new ReplaySubject<IDropdown[]>(1);

  /** local copy of filtered Values to help set the toggle all checkbox state */
  filteredValuesCache: IDropdown[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  @ViewChild('multiSelect', { static: true }) multiSelect: MatSelect;
  @ViewChild('selectSearch', { static: true }) selectSearch: MatSelectSearchComponent;
  /** Subject that emits when the component has been destroyed. */
  _onDestroy = new Subject<void>();

  @Input() set data(value: any) {
    this.setting = value;
  };

  @Input() service;
  @Input() filterKey: string = '';

  @Input() set selectionValues(value: any) {
    this.options = value ? value : [];
    // load the initial value list
    this.filteredValuesMulti.next(this.options?.slice());
    if(this.setting.IsMandatory && this.options.length == 1 && !this.fetchOnSearch && !this.setting['searchData']) {
      if(this.setting?.groupOptions){
        if(this.options[0]?.Value?.length == 1){
          this.formMultiCtrl.setValue([this.options[0]?.Value[0]?.Value]);
        }
      }
      else{
        this.formMultiCtrl.setValue([this.options[0].Value]);
      }
      this.setValue();
    }
  };
  @Input() set form(form: any) {
    // set initial selection
    this.formControl = form;
    this.formMultiCtrl.setValue(form?.value[this.setting.Name]);
    this.mySelections = this.formMultiCtrl.value;
    this.oldValue = form ? ((form.value[this.setting.Name] == "" || form.value[this.setting.Name] == null) ? [] : form.value[this.setting.Name]) : [];
  };
  @Input() isDisable: boolean = false;
  @Input() isShowRefreshButton: boolean = true;
  @Input() isShowCustomLabel: boolean = true;
  @Input() isLableColorWhite: boolean = false;
  @Input() appearance: 'legacy' | 'standard' | 'fill' | 'outline' = 'fill';
  @Input() isParentMandatory: boolean = true;
  @Input() fetchMoreOnScrollEnd: boolean = false;
  @Input() fetchOnSearch: boolean = false;
  @Input() hydrateSelectedOnSearch: boolean = true;
  @Output() convertDataUrl = new EventEmitter();
  @Output() selectionChange = new EventEmitter();
  @Output() createAppComponent = new EventEmitter();

  input$ = new Subject<string>();
  optionSelected = false;

  pageIndex: number = 0;
  filteredData: any;
  private searchRequestId: number = 0;
  @Input() filter: any = {
    Filter: '',
    PageNumber: 0,
    PageSize: 10
  };
  totalData: number = 0;
  

  constructor(
    private toastrService: ToastrService,
    private cd: ChangeDetectorRef,
    private popover: PopoverService,
    private dialog: MatDialog,
  ) { 
    super();
  }

  getDataAttribute(action, label) {
    return action +' '+ label;
  }
  
  ngOnInit() {

    if (this.fetchOnSearch) {
      this.onSearch();
      this.input$.next('');

      // Link the search control to the Subject
      this.formMultiFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((searchText) => {
        if (!this.optionSelected) {
          this.input$.next(searchText);
        }
      });
    } else {
      this.formMultiFilterCtrl.valueChanges
      .pipe(
        takeUntil(this._onDestroy),
        distinctUntilChanged(),
        debounceTime(400)
      )
      .subscribe(() => {
        this.filterValuesMulti();
        this.setToggleAllCheckboxState();
      });
      this.formMultiCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy)).subscribe(() => {
        this.setToggleAllCheckboxState();
      });
    }

    // listen for search field value changes
    

    // listen for multi select field value changes
    
  }

  ngAfterViewInit() {
    this.setInitialValue();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredValuesMulti.pipe(take(1), takeUntil(this._onDestroy))
    .subscribe(val => {
      this.isChecked = selectAllValue;
      this.selectSearch.isChecked = selectAllValue;
      if (selectAllValue) {
        this.formMultiCtrl.setValue(val.map(x=> x.Value));
        this.multiSelect.options.forEach((item: MatOption, i) => {
          if(i > 0)
            item.select()
        });
      } else {
        this.filteredValuesCache.forEach(value => {
          let ind = this.formMultiCtrl.value.findIndex(val => val == value.Value);
          if(ind != -1) {
            this.formMultiCtrl.value.splice(ind, 1);
          }
        })
        this.multiSelect.options.forEach((item: MatOption, i) => {
          if(i > 0)
            item.deselect()
        });
      }
      this.checkLimit(this.formMultiCtrl.value);
    });
  }

  checkLimit(value) {
    if (!this.setting.Max || this.setting.Max == 0 || value.length <= this.setting.Max) {
      this.mySelections = value;
    } else {
      this.formMultiCtrl.setValue(this.mySelections);
      this.toastrService.info("You can't select more than "+this.setting.Max);
    }
  }

  getLable(value) {
    let lable = value;
    if(!this.setting.groupOptions) {
      let opt = this.options.find(option => option.Value == value);
      if(opt) {
        lable = opt.Label;
      }
    } else {
      let filterOptions: any[] = [];
      filterOptions = JSON.parse(JSON.stringify(this.options));
      for(let i = 0; i < filterOptions.length; i++) {
        let opt = filterOptions[i].Value.find(option => option.Value == value);
        if(opt) {
          lable = opt.Label;
          break;
        }
      }
    }
    return lable;
  }

  removeOption(value) {
    let index = this.formMultiCtrl.value.findIndex(option => option == value);
    this.formMultiCtrl.value.splice(index, 1);
    this.multiSelect.options.forEach((item: MatOption) => {
      if(value == item.value)
        item.deselect();
    });
    this.setValue();
  }

  /**
   * Sets the initial value after the filteredValues are loaded initially
   */
  setInitialValue() {
    this.filteredValuesMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.multiSelect.compareWith = (a: IDropdown, b: IDropdown) => a && b && a === b;
      });
  }

  noCompareFunction(){ return 0;}

  isJSON(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  filterValuesMulti() {
    if (!this.options) {
      return;
    }
    // get the search keyword
    let search = this.formMultiFilterCtrl.value;
    if (this.isJSON(this.setting.DataUrl) && !this.optionSelected) { 
      this.setting['searchData'] = search;
      this.onClickRefresh();
    }
    if (!search) {
      this.filteredValuesCache = this.options?.slice();
      this.filteredValuesMulti.next(this.filteredValuesCache);
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the options
    // filter the values
    if(!this.setting.groupOptions) {
      this.filteredValuesCache = this.options.filter(option => option.Label?.toString().toLowerCase().indexOf(search) > -1);
      this.filteredValuesMulti.next(this.filteredValuesCache);
    } else {
      let filterOptions: any[] = [];
      filterOptions = JSON.parse(JSON.stringify(this.options));
      for(let i = 0; i < filterOptions.length; i++) {
        filterOptions[i].Value = filterOptions[i].Value.filter(x=> x.Label?.toLowerCase().includes(search.toLowerCase()))
      }
      this.filteredValuesCache = filterOptions;
      this.filteredValuesMulti.next(this.filteredValuesCache);
    }
  }

  onSearch() {
    this.input$
      .pipe(
        takeUntil(this._onDestroy),
        distinctUntilChanged(),
        debounceTime(400),
        tap((value) => {
          this.pageIndex = 0;
          this.totalData = 0;
          this.filter.Filter = value || null;
          this.filter.PageNumber = this.pageIndex;
          if (this.filterKey && this.hydrateSelectedOnSearch) {
            this.filter[this.filterKey] = Array.isArray(this.formMultiCtrl.value) ? this.formMultiCtrl.value : [];
          }
          this.setting.loader = true;
        }),
        // Do not cancel in-flight POST bodies while the user types; Azure Functions/Kestrel
        // can log aborted dependency-designer select calls as incomplete request content.
        // Instead, let prior requests finish and only render the newest response.
        mergeMap(() => {
          const requestId = ++this.searchRequestId;
          return this.service.getForSelectPaginated({ ...this.filter }).pipe(
            map((data) => ({ data, requestId, failed: false })),
            // A transient/authentication failure must not terminate the shared search stream; reopening or typing
            // in the dropdown should issue a fresh authenticated request.
            catchError(() => of({ data: { selectedItems: [], items: [], totalCount: 0 }, requestId, failed: true }))
          );
        })
      )
      .subscribe(
        ({ data, requestId }: any) => {
        if (requestId !== this.searchRequestId) {
          return;
        }
        this.filteredData = this.mergePagedOptions(data?.selectedItems || [], data?.items || []);
        this.filteredValuesMulti.next(this.filteredData);
        this.totalData = data.totalCount;
        this.setting.loader = false;
      },
      (error) => {
        this.setting.loader = false;
      });
  }

  setToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.formMultiCtrl && this.formMultiCtrl.value) {
      this.filteredValuesCache.forEach(el => {
        if (this.formMultiCtrl.value.indexOf(el.Value) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate = filteredLength > 0 && filteredLength < this.filteredValuesCache.length;
      this.isChecked = filteredLength > 0 && filteredLength === this.filteredValuesCache.length;
    }
  }

  onClickRefresh(){
    this.convertDataUrl.emit();
  }

  onClose() {
    this.multiSelect.options.forEach((item: MatOption) => item.deselect());
    this.multiSelect.options.forEach((item: MatOption) => {
    if(this.oldValue && this.oldValue?.find(val => val == item.value))
        item.select();
    });
    this.filterValuesMulti();
    this.setToggleAllCheckboxState();
    this.isChecked = false;
    this.selectSearch.isChecked = false;
    this.multiSelect.close();
  }

  setValue(){
    let value = this.formMultiCtrl.value;
    if(JSON.stringify(this.oldValue) != JSON.stringify(value)) {
      this.formControl?.get(this.setting.Name)?.markAsDirty();
    }
    this.oldValue = value;
    this.formControl?.get(this.setting.Name)?.setValue(value);
    this.selectionChange.emit(value);
    this.multiSelect.close(); 
  }

  registerPanelScrollEvent() {
    const panel = this.multiSelect.panel?.nativeElement;
    panel?.addEventListener('scroll', (event) => this.loadAllOnScroll(event));
  }

 loadAllOnScroll(event: Event) {
    const element = event.target as HTMLElement;
    const remainingScroll = element.scrollHeight - element.clientHeight - element.scrollTop;
    const atBottom = remainingScroll <= 5;
    if (
      atBottom &&
      this.fetchMoreOnScrollEnd &&
      !this.setting.loader
    ) {
      this.fetchMore();
    }
  }

  fetchMore() {
    if (this.getOptionCount(this.filteredData) >= this.totalData) {
      return;
    }
    this.setting.loader = true;
    this.pageIndex++;
    this.filter.PageNumber = this.pageIndex;
    this.service.getForSelectPaginated(this.filter).pipe(takeUntil(this._onDestroy)).subscribe((result) => {
      this.filteredData = this.mergePagedOptions(this.filteredData, result.items || []);
      this.filteredValuesMulti.next(this.filteredData);
      this.setting.loader = false;
    });
  }

  mergePagedOptions(currentOptions: any[] = [], nextOptions: any[] = []) {
    if (!this.setting.groupOptions) {
      return currentOptions.concat(nextOptions);
    }

    const groups = JSON.parse(JSON.stringify(currentOptions || []));
    (nextOptions || []).forEach((incomingGroup) => {
      const group = groups.find((option) => option.Label === incomingGroup.Label);
      if (!group) {
        groups.push(incomingGroup);
        return;
      }

      group.Value = group.Value || [];
      (incomingGroup.Value || []).forEach((incomingOption) => {
        if (group.Value.findIndex((option) => option.Value === incomingOption.Value) === -1) {
          group.Value.push(incomingOption);
        }
      });
    });
    return groups;
  }

  getOptionCount(options: any[] = []) {
    if (!this.setting.groupOptions) {
      return options?.length || 0;
    }

    return (options || []).reduce((total, group) => total + (group.Value?.length || 0), 0);
  }

  isShowError() {
    let status: boolean = false;
    if(this.formControl?.get(this.setting.Name)) {
      if(!this.formControl.get(this.setting.Name).valid){
        if(!this.isParentMandatory) {
          status = this.formControl?.get(this.setting.Name).dirty;
        } else {
          status = this.formControl?.get(this.setting.Name).dirty || this.formControl?.get(this.setting.Name).touched;
        }
      }
    }
    return status;
  }

  onToggleSelect(event){
    if(!event) {
      this.formControl?.get(this.setting.Name)?.markAsTouched();
    } else {
      this.resetSearchOnOpen();
      this.registerPanelScrollEvent();
    }
  }

  private resetSearchOnOpen() {
    if (!this.formMultiFilterCtrl.value) {
      return;
    }

    // Reopening the select should show the unfiltered option list, not the last typed query.
    this.optionSelected = false;
    this.formMultiFilterCtrl.setValue('');
    if (this.fetchOnSearch) {
      this.input$.next('');
    } else {
      this.filterValuesMulti();
      this.setToggleAllCheckboxState();
    }
  }

  showInfo(origin: ElementRef | HTMLElement, text: string) {
    if(this.setting.IsShowFullInstructions) {
      this.toggleReadMore();
    } else {
      this.popover.open({
        content: PopoverTooltipComponent,
        origin,
        data: { heading: 'Instructions', text: text },
        position: [
            {
            originX: 'start',
            originY: 'top',
            overlayX: 'start',
            overlayY: 'bottom'
            },
            {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top'
            }
        ]
      });
    }
  }

  toggleReadMore(){
    this.dialog.open(TooltipReadMoreComponent, {
      width: '98%',
      maxWidth: '98vw',
      height: '95%',
      maxHeight: '95vw',
      disableClose: true,
      data: {Text: this.setting.Instructions, Heading: 'Instructions'}
    });
  }
}
